function getFormattedMovieDescription(data) {
    const hours = Math.floor(data / 60);
    const hoursString = hours ? `${hours} t ` : '';
    const minutes = data - (hours * 60);
    const minutesString = `${minutes} min`;

    return `${hoursString}${minutesString}`;
}

export {
    getFormattedMovieDescription
}